module.exports = __webpack_public_path__ + "static/media/community.b39de4fc.svg";